/* BABYGO blog article (sections/main-article.liquid, 25 Sep 2026).
   Works on the article body as published:
   - "On this page": the article's own contents list if it has one, otherwise one built from its H2s (ids added only
     where a heading has none, with the same rule as before, so shared links keep working). Shown inline before the
     first section, in a sheet from the bar under the header below 1200px, and in the left margin from 1200px.
   - FAQ: an H2 that starts "Questions", "FAQ" or "Frequently", followed by H3 questions ending in "?", becomes an
     accordion. Answers stay in the page (details), the first is open, the FAQPage JSON-LD in the body is untouched.
   - Stacked tables (.bg-stack) keep table semantics through ARIA roles; other tables get a scroll box on phones.
   Sheets open and close through assets/bg-pdp.js ([data-pdp-dialog-open], dialog.bgp-sheet). */
(function () {
  'use strict';
  var root = document.querySelector('[data-bga]');
  if (!root || root.__bgA) return;
  root.__bgA = true;
  var body = root.querySelector('[data-bga-body]');
  if (!body) return;

  var docEl = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var wide = window.matchMedia('(min-width: 1200px)');
  var label = root.getAttribute('data-bga-contents-label') || 'On this page';
  var minSections = parseInt(root.getAttribute('data-bga-contents-min'), 10) || 3;
  var FAQ = /^(questions|faq|frequently)/i;

  function $all(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }
  function text(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }
  /* Same id rule as the jump links added on 18 Sep 2026. */
  function makeId(el) {
    if (el.id) return el.id;
    var base = (el.textContent || '').trim().toLowerCase().replace(/['’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section';
    var id = base;
    for (var n = 2; document.getElementById(id); n++) id = base + '-' + n;
    el.id = id;
    return id;
  }

  /* ---------- Tables ---------- */
  $all('table', body).forEach(function (t) {
    if (t.classList.contains('bg-stack')) {
      t.setAttribute('role', 'table');
      $all('thead, tbody, tfoot', t).forEach(function (g) { g.setAttribute('role', 'rowgroup'); });
      $all('tr', t).forEach(function (tr) { tr.setAttribute('role', 'row'); });
      $all('thead th, thead td', t).forEach(function (c) { c.setAttribute('role', 'columnheader'); });
      $all('tbody tr', t).forEach(function (tr) {
        Array.prototype.forEach.call(tr.children, function (c, i) { c.setAttribute('role', i === 0 ? 'rowheader' : 'cell'); });
      });
      var wrap = t.parentElement;
      if (wrap && wrap !== body && wrap.children.length === 1) wrap.classList.add('bgA-table-wrap');
      else {
        var w = document.createElement('div');
        w.className = 'bgA-table-wrap';
        t.parentNode.insertBefore(w, t);
        w.appendChild(t);
      }
    } else if (!t.closest('.bgA-scroll')) {
      var s = document.createElement('div');
      s.className = 'bgA-scroll';
      t.parentNode.insertBefore(s, t);
      s.appendChild(t);
    }
  });

  /* ---------- Heading ids: sections first, in page order (as before), then the questions heading ---------- */
  var heads = $all('h2', body).filter(function (h) { return text(h); });
  var sections = heads.filter(function (h) { return !FAQ.test(text(h)); });
  /* The article's own contents list: the old .article--contents__list, or any list whose items are each one
     in-page link ("On this page" / "Contents:" lists written into newer posts). It is kept and restyled. */
  function isContentsList(list) {
    var items = Array.prototype.filter.call(list.children, function (c) { return c.tagName === 'LI'; });
    if (items.length < 2) return false;
    return items.every(function (li) {
      var links = li.querySelectorAll('a');
      if (links.length !== 1) return false;
      var href = links[0].getAttribute('href') || '';
      return href.charAt(0) === '#' && href.length > 1 && text(li) === text(links[0]);
    });
  }
  var authored = body.querySelector('.article--contents__list, .bg-toc') || $all('ul, ol', body).filter(isContentsList)[0] || null;
  if (authored && !authored.closest('.article--contents__list--wrap, .bg-toc')) {
    authored.classList.add('bgA-toc-list');
    var lab = authored.previousElementSibling;
    if (!lab && authored.parentElement !== body) lab = authored.parentElement.previousElementSibling;
    if (lab && /^(p|h2|h3|h4|span)$/i.test(lab.tagName) && /^(on this page|contents|article contents)\s*:?$/i.test(text(lab))) lab.classList.add('bgA-toc-label');
  }
  var buildList = !authored && sections.length >= minSections;
  if (buildList) sections.forEach(makeId);

  /* ---------- FAQ accordions ---------- */
  heads.forEach(function (h) {
    if (!FAQ.test(text(h))) return;
    var items = [];
    var n = h.nextElementSibling;
    while (n && n.tagName === 'H3' && /\?\s*$/.test(text(n))) {
      var q = n, answer = [];
      n = n.nextElementSibling;
      while (n && /^(P|UL|OL)$/.test(n.tagName) && !n.classList.contains('bg-note')) { answer.push(n); n = n.nextElementSibling; }
      if (!answer.length) break;
      items.push({ q: q, a: answer });
    }
    if (!items.length) return;
    makeId(h);
    var sec = document.createElement('section');
    sec.className = 'bgA-faq';
    sec.setAttribute('aria-labelledby', h.id);
    h.parentNode.insertBefore(sec, h);
    sec.appendChild(h);
    var list = document.createElement('div');
    list.className = 'bgA-faq__list';
    items.forEach(function (it, i) {
      var det = document.createElement('details');
      det.className = 'bgA-faq__item';
      if (i === 0) det.open = true;
      var sum = document.createElement('summary');
      sum.className = 'bgA-faq__q';
      sum.appendChild(it.q);
      var mark = document.createElement('span');
      mark.className = 'bgA-faq__mark';
      mark.setAttribute('aria-hidden', 'true');
      sum.appendChild(mark);
      var ans = document.createElement('div');
      ans.className = 'bgA-faq__a';
      it.a.forEach(function (el) { ans.appendChild(el); });
      det.appendChild(sum);
      det.appendChild(ans);
      list.appendChild(det);
    });
    sec.appendChild(list);
  });

  /* ---------- Contents entries ---------- */
  var entries = [];
  var inline = null;
  if (authored) {
    inline = authored.closest('.article--contents__list--wrap') || authored;
    $all('a[href^="#"]', authored).forEach(function (a) {
      var id = decodeURIComponent(a.getAttribute('href').slice(1));
      var target = id && document.getElementById(id);
      if (target && body.contains(target)) entries.push({ id: id, label: text(a), target: target });
    });
  } else if (buildList) {
    heads.forEach(function (h) {
      makeId(h);
      entries.push({ id: h.id, label: text(h), target: h });
    });
    var nav = document.createElement('nav');
    nav.className = 'bg-toc bgA-toc';
    nav.setAttribute('aria-labelledby', 'bgA-toc-label');
    var p = document.createElement('p');
    p.className = 'bgA-label';
    p.id = 'bgA-toc-label';
    p.textContent = label;
    nav.appendChild(p);
    nav.appendChild(listOf(entries));
    var anchor = FAQ.test(text(heads[0])) ? sections[0] : heads[0];
    anchor.parentNode.insertBefore(nav, anchor);
    inline = nav;
  }

  function listOf(items) {
    var ul = document.createElement('ul');
    ul.setAttribute('role', 'list');
    items.forEach(function (e) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + e.id;
      /* hyphenated words (c-section) stay whole on a line, as in the title */
      e.label.split(' ').forEach(function (w, i) {
        if (i) a.appendChild(document.createTextNode(' '));
        if (w.indexOf('-') > 0) { var s = document.createElement('span'); s.className = 'bgA-nowrap'; s.textContent = w; a.appendChild(s); }
        else a.appendChild(document.createTextNode(w));
      });
      li.appendChild(a);
      ul.appendChild(li);
    });
    return ul;
  }

  var bar = root.querySelector('[data-bga-bar]');
  var margin = root.querySelector('[data-bga-margin]');
  var sheet = document.getElementById('bgA-contents');
  var sheetList = sheet && sheet.querySelector('[data-bga-sheet-list]');
  var marginList = margin && margin.querySelector('[data-bga-margin-list]');
  var spyLinks = [];

  if (entries.length) {
    if (sheetList) { var sl = listOf(entries); while (sl.firstChild) sheetList.appendChild(sl.firstChild); spyLinks = spyLinks.concat($all('a', sheetList)); }
    if (marginList) { var ml = listOf(entries); while (ml.firstChild) marginList.appendChild(ml.firstChild); spyLinks = spyLinks.concat($all('a', marginList)); }
    if (bar) bar.hidden = false;
    if (margin) margin.hidden = false;
    root.classList.add('bgA--has-contents');
  }

  /* ---------- Offsets under the sticky header (and the contents bar below 1200px) ---------- */
  function headerHeight() {
    var header = document.querySelector('.header-section');
    if (!header) return 0;
    var pos = getComputedStyle(header).position;
    return (pos === 'sticky' || pos === 'fixed') ? header.getBoundingClientRect().height : 0;
  }
  function barHeight() { return bar && !bar.hidden && !wide.matches ? (bar.offsetHeight || 44) : 0; }
  function offset() { return headerHeight() + barHeight() + 16; }

  function scrollToTarget(target, smooth) {
    var det = target.closest('details');
    if (det && !det.open) det.open = true;
    var y = target.getBoundingClientRect().top + window.pageYOffset - offset();
    window.scrollTo({ top: Math.max(0, y), behavior: smooth && !reduced.matches ? 'smooth' : 'auto' });
  }
  function go(target) {
    scrollToTarget(target, true);
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
    if (history.replaceState) history.replaceState(null, '', '#' + target.id);
  }

  var pending = null;
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var inSheet = sheet && sheet.contains(a);
    if (!inSheet && !root.contains(a)) return;
    var id = decodeURIComponent(a.getAttribute('href').slice(1));
    var target = id && document.getElementById(id);
    if (!target || target.tagName === 'DIALOG') return;
    e.preventDefault();
    if (inSheet && sheet.open) { pending = target; sheet.close(); return; }
    go(target);
  });
  /* bg-pdp.js puts focus back on the opener in its own close handler (document, capture); this runs after it. */
  if (sheet) sheet.addEventListener('close', function () {
    if (!pending) return;
    var t = pending;
    pending = null;
    requestAnimationFrame(function () { go(t); });
  });

  /* ---------- Bar, margin list and the current section ---------- */
  var start = inline || (entries[0] && entries[0].target);
  function update() {
    if (!entries.length) return;
    var top = headerHeight();
    var passed = start ? start.getBoundingClientRect().bottom < top : false;
    var bodyRect = body.getBoundingClientRect();
    var inside = bodyRect.bottom > top + 120;
    if (bar) {
      var show = passed && inside && !wide.matches;
      if (show !== bar.classList.contains('is-shown')) {
        bar.classList.toggle('is-shown', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        var b = bar.querySelector('button');
        if (b) b.tabIndex = show ? 0 : -1;
      }
    }
    docEl.style.setProperty('--bga-header-h', top + 'px');
    var line = offset() + 8;
    var current = null;
    entries.forEach(function (en) { if (en.target.getBoundingClientRect().top <= line) current = en.id; });
    if (!current && passed) current = entries[0].id;
    spyLinks.forEach(function (a) {
      if (current && a.getAttribute('href') === '#' + current) a.setAttribute('aria-current', 'location');
      else a.removeAttribute('aria-current');
    });
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; update(); });
  }

  /* The margin list starts beside the first section, then stays in view as the page scrolls. */
  function placeMargin() {
    if (!margin || !entries.length) return;
    if (!wide.matches) { margin.style.removeProperty('--bga-margin-start'); return; }
    var layout = margin.parentElement;
    var first = entries[0].target;
    var y = first.getBoundingClientRect().top - layout.getBoundingClientRect().top;
    margin.style.setProperty('--bga-margin-start', Math.max(0, Math.round(y)) + 'px');
  }

  if (entries.length) {
    if (bar) { bar.setAttribute('aria-hidden', 'true'); var bb = bar.querySelector('button'); if (bb) bb.tabIndex = -1; }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { placeMargin(); onScroll(); });
    if (wide.addEventListener) wide.addEventListener('change', function () { placeMargin(); onScroll(); });
    window.addEventListener('load', function () { placeMargin(); update(); });
    if (window.ResizeObserver) new ResizeObserver(function () { placeMargin(); }).observe(body);
    placeMargin();
    update();
  }

  /* A link into the page (from search, a share or another post) lands under the header and the bar. */
  if (location.hash.length > 1) {
    var landing = document.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (landing && root.contains(landing)) {
      window.addEventListener('load', function () {
        setTimeout(function () { scrollToTarget(landing, false); update(); }, 150);
      });
    }
  }
})();

/* ---------- Advertising slots (17 Oct 2026) ----------
   Clicks on any unit ([data-bg-ad]) publish blog_ad_click with the slot, the creative, the article and the stage,
   through the same dataLayer + Shopify.analytics.publish pair as fyb.js (GA4 needs the custom pixel to subscribe
   to the name). The phone shop bar shows once a quarter of the body has gone by and hides again at its end. */
(function () {
  'use strict';
  var root = document.querySelector('[data-bga]');
  if (!root || root.__bgAds) return;
  root.__bgAds = true;
  var w = window;
  function track(ev, extra) {
    var o = { event: ev }; if (extra) for (var k in extra) o[k] = extra[k];
    try { w.dataLayer = w.dataLayer || []; w.dataLayer.push(o); } catch (e) {}
    try {
      if (w.Shopify && w.Shopify.analytics && typeof w.Shopify.analytics.publish === 'function') w.Shopify.analytics.publish(ev, extra || {});
    } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a, button');
    if (!a) return;
    var ad = a.closest('[data-bg-ad]');
    if (!ad) return;
    track('blog_ad_click', {
      ad_slot: ad.getAttribute('data-bg-ad') || '',
      ad_creative: ad.getAttribute('data-bg-ad-creative') || '',
      ad_article: root.getAttribute('data-bga-article') || '',
      ad_stage: root.getAttribute('data-bga-stage') || '',
      ad_href: a.getAttribute('href') || ''
    });
  });

  var body = root.querySelector('[data-bga-body]');
  var bar = document.querySelector('[data-bga-shop]');
  if (!body || !bar) return;
  var phone = w.matchMedia('(max-width: 767px)');
  var btn = bar.querySelector('a');
  var shown = false;
  bar.hidden = false;
  function update() {
    var r = body.getBoundingClientRect();
    var vh = w.innerHeight || document.documentElement.clientHeight;
    var progress = r.height > 0 ? (vh - r.top) / r.height : 0;
    var show = phone.matches && progress > 0.25 && r.bottom > vh - 80;
    if (show === shown) return;
    shown = show;
    bar.classList.toggle('is-shown', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (btn) btn.tabIndex = show ? 0 : -1;
    document.body.classList.toggle('bgA-shop-shown', show);
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; update(); });
  }
  w.addEventListener('scroll', onScroll, { passive: true });
  w.addEventListener('resize', onScroll);
  if (phone.addEventListener) phone.addEventListener('change', update);
  update();
})();
